export const PERCH_API_BASE =
  process.env['NEXT_PUBLIC_PERCH_API_BASE'] ?? 'https://api.perch.neuralway.ai';

export async function authError(res: Response, fallback: string): Promise<string> {
  const contentType = res.headers.get('content-type') ?? '';
  if (!contentType.includes('application/json')) return fallback;

  const body = (await res.json().catch(() => null)) as {
    error?: unknown;
    message?: unknown;
  } | null;
  if (typeof body?.message === 'string') return body.message;
  if (typeof body?.error === 'string') return body.error;
  return fallback;
}

export async function hasCustomerSession(): Promise<boolean> {
  try {
    const res = await fetch(`${PERCH_API_BASE}/v1/auth/session`, {
      credentials: 'include',
      headers: { accept: 'application/json' },
      cache: 'no-store',
    });
    return res.ok;
  } catch {
    return false;
  }
}
